import { tableHeadPositive } from '../../constants';

export const getFlex = (index: number) => {
  const currentHead = tableHeadPositive.find((_, i) => i === index);
  return currentHead?.flex || 1;
};
